import React from 'react';
import jurisprudencia from 'assets/images/icone-jurisprudencia.svg';
import DicaLegal from 'assets/images/icone-dica-legal.svg';
import Legislacao from 'assets/images/icone-legislacao.svg';
import Sumula from 'assets/images/icone-sumula.svg';

interface JuridicoThemeCardProps {
  description: string;
  id: number;
}

const JuridicoThemeCard: React.FC<JuridicoThemeCardProps> = ({ description, id }) => {
  const getImageSrc = () => {
    switch (id) {
      case 1:
        return jurisprudencia;
      case 2:
        return DicaLegal;
      case 3:
        return Sumula;
      default:
        return Legislacao;
    }
  };

  return (
    <div className="col-md py-2">
      <div className="card shadow pt-4 h-100">
        <img
          src={getImageSrc()}
          alt={description}
          className="card-img-top shortcut mx-auto img-card mt-2"
        />
        <div className="card-body text-center">
          <h5 className="py-2 font-weight-bold">{description}</h5>
          {id === 4 ? (
            <a href="/legislacao" className="btn btn-sm btn-primary">
              Acessar
            </a>
          ) : (
            <a href={`/juridico/view/tipos/${id}`} className="btn btn-sm btn-primary">
              Acessar
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default JuridicoThemeCard;
